import {prodHost} from "src/components/_common/_constants";

export const getCanonicalLink = (asPath: string): string => prodHost + asPath.replace(/\?(.*)/, "");

export const getLinkWithLocale = (asPath: string, locale: string): string =>
  locale === "en"
    ? getCanonicalLink(asPath)
    : prodHost + "/" + locale + asPath.replace(/\?(.*)/, "");
